// extracted by mini-css-extract-plugin
module.exports = {"field":"ReceiptArchiveFilter_field__2LcHc"};